module.exports = __webpack_public_path__ + "img/books-stack-of-three-green.500f23a3.svg";